/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![WindowLaunchIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA9ElEQVR4nO2VSwrCQAxA1YU3qHgW0X0RJ0kXIRG8S5fWa1lc6kIFT1CvURnrr9bROrgQNDCbIfPeJC2ZRuObw5AugDR/uFDSUjIzt4FkZlD2dQ8BSurMJc1LAiBNniUDaW5I565qomjSAdSNU2BIMruJKL13WxVZOMm2qPIqua+gulkjQubgAkXZDZm7HxOEzIEhWd/CnSwPQdOQrM5tsbKnrHcFcRy37K0BdXkLP7JQ0soP4fsNasdfUBof92Piky0CF+cv+IEWmdO4HtG47wtHlEHxbkj2yPzywYGay6BOK4LiydTkXIkXmI5nE8vy7cL3xQEZgSyWGzTRcgAAAABJRU5ErkJggg==)
 */
export const WindowLaunchIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15 2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V4.41l-4.3 4.3a1 1 0 1 1-1.4-1.42L19.58 3H16a1 1 0 0 1-1-1Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 1 0-2 0v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6a1 1 0 1 0 0-2H5Z"
        className={colorClass}
      />
    </svg>
  );
};
